import { Field, Form } from 'formik';
import { AppointmentSubform } from '@forms/Appointment/Form';
import DriverField from '@forms/Fields/Driver';
import { Leg } from '@api/Trinium/Endpoints/Leg';
import { LegStatus } from '@api/Trinium/types';

import styles from './FormikForm.module.css';

interface FormikFormProps {
  id: string;
  leg: Leg;
}

/**
 * Manage Pickup and Delivery Form
 */
export default function FormikForm({ id, leg }: FormikFormProps) {
  return (
    <Form
      className={styles.form}
      id={id}>
      <div className={styles['flex-row']}>
        <Field
          name='pickupForm'
          component={AppointmentSubform}
          label='Pickup'
          usePickupNotes
        />

        <Field
          name='deliveryForm'
          component={AppointmentSubform}
          label='Delivery'
          useDeliveryNotes
        />
      </div>

      <DriverField
        fieldName='assignedDriver'
        className={styles['driver-button']}
        mode={{
          Drivers: {
            enabled: true
          },
          Tractors: {
            enabled: true
          },
          Carriers: {
            enabled: true
          },
          Salespeople: {
            enabled: false
          },
          requiresHazmat: leg.reqHazmatCert,
          renderActionProps: {
            legId: leg.id,
            isDriverAssigned: !!leg.drvId,
            driverEmail: leg.drv?.emailAddr,
            driverCellPhone: leg.drv?.cellPhone,
            puDlReceiptSent: leg.puDelvReceiptSent,
            jobId: leg.jobId,
            csnId: Number(leg.csnId),
            custRefNo: leg.csn.custRefNo || undefined,
            bookingRefNo: leg.job?.bookingRefNo,
            cntrId: leg.cntrId,
            isHazmat: leg.isHazmat,
            isImport: leg.job?.catTransType === 'I',
            isExport: leg.job?.catTransType === 'E'
          }
        }}
        disabled={leg.status && [LegStatus.DL, LegStatus.PU].includes(LegStatus[leg.status])}
        clearable={leg.status && [LegStatus.NA, LegStatus.AV, LegStatus.OS].includes(LegStatus[leg.status])}
      />
    </Form>
  );
}
